// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__6mpUu","h1":"Error_h1__mpkBo","p":"Error_p__XMZLH"};